<template>
  <div>
    <div class="exp_button">
      <button @click="exportMdText" class="btn">Export</button>
    </div>
    <div class="markdown-container">
      <Markdown :source="mdText" />
    </div>
  </div>
</template>

<script>
import Markdown from 'vue3-markdown-it'

export default {
  components: {
    Markdown
  },
  data() {
    let mdText = "";
    return { mdText }
  },
  setup() {
    return {}
  },
  methods: {
    drawMDText(mdText){
      this.mdText = mdText;
    },
    clearMdText(){
      this.mdText = "";
    },
    exportMdText() {
      if (this.mdText.length != 0) {
        const blob = new Blob([this.mdText], { type: 'text/markdown;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exported.md'); // 저장될 파일명
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url); // 메모리 해제
      } else {
        alert("Export 데이터가 없습니다.");
        return;
      }
    }
  }
}
</script>

<style scoped>
::v-deep(*)
{
  all: revert;
}
</style>

<style>
.markdown-container {
  width: 100%;
  max-width: 1220px;
  height: 700px; /* 고정 높이 설정 */
  overflow-y: auto; /* 세로 스크롤 활성화 */
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fafafa;
  margin-top: 10px;
}

.markdown-container table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 16px;
  text-align: left;
}

.markdown-container th,
.markdown-container td {
  padding: 10px;
  border: 1px solid #ddd; /** default border line **/
}

.markdown-container th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.exp_button {
  width: 670px;
  display: flex;
  justify-content: flex-end;
}

.btn {
  display: inline-block;
  padding: 8px 8px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: #c7c7c7;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.btn:hover {
  background-color: #12a1d5;
}

.btn:active {
  transform: scale(0.95);
}
</style>